import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getDenominationDashboardStats = ({ denominationId }) => {
  return axios.get(`/denominations/${denominationId}/dashboard-totals`);
};

export const useDenominationDashboardStats = ({
  config,
  denominationId
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["denomination-dashboard-stats", denominationId],
    queryFn: () => getDenominationDashboardStats({ denominationId }),
    enabled: !!denominationId,
    select: data => data.result
  });
};
